<template>
  <div class="flex w-full items-center justify-between gap-2 md:gap-0">
    <HitCounter class="hidden lg:block" />
    <MobileFilters
      v-if="
        productStore.filters.length > 0 && productStore.enableAlgoliaFilters
      "
    />
    <div v-else></div>
    <SortSelectWrapper />
  </div>
  <div class="mt-4 block lg:hidden">
    <HitCounter />
  </div>
  <AisInfiniteHits class="mt-6">
    <template #default="{ items, refineNext, isLastPage, sendEvent }">
      <div
        v-auto-animate
        :class="[
          'grid gap-6',
          productStore.filters.length > 0 ? 'lg:grid-cols-3' : 'lg:grid-cols-4',
          items.length > 1 ? 'grid-cols-2' : 'grid-cols-1 md:grid-cols-2',
        ]"
      >
        <ProductHit
          v-for="item in items"
          :key="item.objectID"
          :hit="item"
          @on-item-click="() => sendEvent('click', item, 'Hit Clicked')"
        />
      </div>
      <InViewChecker
        v-if="!isLastPage && items.length > 0"
        @in-view="refineNext"
      />
    </template>
  </AisInfiniteHits>
</template>

<script setup lang="ts">
import InViewChecker from '@/components/States/InViewChecker.vue';
import HitCounter from '@/pages/CategoryPage/Partials/HitCounter.vue';
import MobileFilters from '@/pages/CategoryPage/Partials/MobileFilters.vue';
import ProductHit from '@/pages/CategoryPage/Partials/ProductHit.vue';
import SortSelectWrapper from '@/pages/CategoryPage/Partials/SortSelectWrapper.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';

const productStore = useAlgoliaProductStore();
</script>
